import { render, staticRenderFns } from "./AddPurchasesInvoiceComponent.vue?vue&type=template&id=450bf23d&"
import script from "./AddPurchasesInvoiceComponent.vue?vue&type=script&lang=js&"
export * from "./AddPurchasesInvoiceComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports